import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container full-height" }
const _hoisted_2 = { class: "row flex-fill" }
const _hoisted_3 = { class: "col-md-9 text-start" }
const _hoisted_4 = { class: "d-flex flex-row mb-2 mt-4" }
const _hoisted_5 = {
  key: 0,
  class: "d-flex justify-content-end bold"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "col-md-3 d-flex summary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CartViewItem = _resolveComponent("CartViewItem")!
  const _component_Summary = _resolveComponent("Summary")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "flex-grow-1" }, [
            _createElementVNode("h5", { class: "bold" }, "Your cart")
          ], -1)),
          (_ctx.cartStore.cart.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Containing " + _toDisplayString(_ctx.cartStore.cart.length +
              " " +
              (_ctx.cartStore.cart.length == 1 ? "product" : "products")), 1))
            : _createCommentVNode("", true)
        ]),
        (!_ctx.cartStore.hasAnyItems())
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, "Cart is empty."))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cartStore.cart, (item, index) => {
          return (_openBlock(), _createBlock(_component_CartViewItem, {
            key: item.product.itemId + '-' + index,
            productData: item.product,
            quantity: item.quantity,
            discount: item.discount,
            itemData: item,
            isCart: true
          }, null, 8, ["productData", "quantity", "discount", "itemData"]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_Summary)
      ])
    ])
  ]))
}